import React from "react";
import { Section, Gallery, Card, Icon, CardTitle } from "./frameworkStyled";

const frameworks = [
  {
    src: "https://res.cloudinary.com/dywqyzge2/image/upload/v1771554715/React-Logo-3546296513_pik3ct.png",
    alt: "React",
    title: "React",
    desc: "Front-end library for building interactive UI",
  },
  {
    src: "https://res.cloudinary.com/dywqyzge2/image/upload/v1771466065/Untitled-1_2_tnjnkc.svg",
    alt: "NextJs",
    title: "NextJs",
    desc: "Front-end library for building interactive UI",
  },
  {
    src: "https://res.cloudinary.com/dywqyzge2/image/upload/v1771555122/django-logo-icon-png-svg_jremje.png",
    alt: "Django",
    title: "Django",
    desc: "Full-stack Python framework for web apps",
  },
  {
    src: "https://res.cloudinary.com/dywqyzge2/image/upload/v1771555337/flask_d0i4uw.png",
    alt: "Flask",
    title: "Flask",
    desc: "Lightweight Python framework for APIs",
  },
  {
    src: "https://res.cloudinary.com/dywqyzge2/image/upload/v1771293478/fastapi-icon-3132635039_urlrgf.svg",
    alt: "FastAPI",
    title: "FastAPI",
    desc: "Modern, fast Python web framework",
  },
  {
    src: "https://res.cloudinary.com/dywqyzge2/image/upload/v1771474934/logo-laravel-icon-1024-3794247781_uf04ie.png",
    alt: "Laravel",
    title: "Laravel",
    desc: "Modern PHP framework for building web applications with elegant syntax and powerful tools"

  },
  // Add more frameworks here
];

const FrameworksSection = () => {
  return (
    <Section id="frameworks">
      <Gallery>
        {frameworks.map((fw, idx) => (
          <Card key={idx}>
            <Icon src={fw.src} alt={fw.alt} loading="lazy" />
            <CardTitle>{fw.title}</CardTitle>
            {/* <CardDesc>{fw.desc}</CardDesc> */}
          </Card>
        ))}
      </Gallery>
    </Section>
  );
};

export default FrameworksSection;
